<h2 mat-dialog-title>Ingresar Observación</h2>
<div mat-dialog-content>
    <textarea name="observation" matInput #input maxlength="800" [(ngModel)]="textInput" placeholder="Ingresar Observación"></textarea>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onSaveClick()">Guardar</button>
</div>